module.exports = __webpack_public_path__ + "static/media/ic-pickup-location.882f2215.svg";